import { Button, H1, HStack, Icon, Text } from '@betterment/samba-react';
import { useNavigate } from 'react-router-dom';

import { WorkflowLayout } from '../../Shared/layout/WorkflowLayout';
import { urlBuilder } from '../../Shared/urlBuilder';
import { useAdhocDocumentVerificationStep } from '../FlowConfig';

export const Instructions = () => {
  const navigate = useNavigate();
  const { commit } = useAdhocDocumentVerificationStep('instructions');

  const handleContinue = () => {
    commit({});
    void navigate('../upload');
  };

  return (
    <WorkflowLayout
      pageTitle="Document Verification"
      onClose={() => navigate(urlBuilder.appHome.path)}
      workflowTitle="Identity Check"
      size="medium"
    >
      <H1 css={{ marginBottom: 'space.200' }}>Verify your identity with your mobile phone.</H1>
      <Text as="p" color="text.weak" css={{ lineHeight: { base: 'normal', md: 'relaxed' }, marginBottom: 'space.600' }}>
        We're going to ask you to use your phone to take a photo of your ID and of yourself. This is to verify that your
        face matches the one on your photo ID.
      </Text>
      <Text as="p" color="text.weak" css={{ fontWeight: 'bold' }}>
        Here's what you need to continue:
      </Text>
      <HStack css={{ justifyContent: 'flex-start', marginBottom: 'space.300' }}>
        <Icon name="CheckFront" size="small" css={{ marginRight: 'space.150' }} />
        <Text as="p" color="text.weak">
          A U.S. driver's license or U.S. Passport
        </Text>
      </HStack>
      <HStack css={{ justifyContent: 'flex-start', marginBottom: 'space.300' }}>
        <Icon name="Camera" size="small" css={{ marginRight: 'space.150' }} />
        <Text as="p" color="text.weak">
          The ability to take a photo of yourself with your phone camera
        </Text>
      </HStack>
      <HStack
        css={{
          gap: 'space.300',
          marginTop: 'space.300',
          flexDirection: { base: 'column', md: 'row' },
          alignItems: 'flex-start',
        }}
      >
        <Button css={{ width: { base: '100%', md: 'auto' } }} onClick={handleContinue}>
          Continue
        </Button>
      </HStack>
    </WorkflowLayout>
  );
};
